export default __webpack_public_path__ + "assets/d44c34.svg";